module.exports = __webpack_public_path__ + "img/active_06.bcfd3b64.jpg";